// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$collegeDepartmentApiService = {
      department_api_url: `${process.env.VUE_APP_COURSE_API_URL}/departments`,
      
      /**
       * 透過 ID 取得班別
       * @param {string} id - ID
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getById(id, additional = '') {
        const url = `${this.department_api_url}/${id}`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      }
    }
  }
}
